export const ITEM_HEIGHT = 36;
export const ROW_PADDING_LEFT = 16;
export const CHECKBOX_WIDTH = 32;
export const CHEVRON_SIZE = 24;
export const LEVEL_INDENT_BASE = 24;
export const LEVEL_INDENT_INCREMENT = 32;
export const CLICK_DELAY = 200;
/**
 * Trailing auto-generated index suffix that search-db appends to disambiguate
 * sibling objects, e.g. the " (69)" in "Upholstery Arms (69)". Capture group 1
 * is the clean base name. Parentheses are required so legitimate trailing
 * numbers (e.g. "Level 1", "Grid 100") are preserved.
 */
export const INDEX_SUFFIX_PATTERN = /^(.+?)\s+\(\d+\)$/;
